import { Component, OnInit } from '@angular/core';
import { Bericht } from '../shared/models/Bericht';
import { BerichtenService } from '../shared/berichtenservice/berichten.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-overzicht',
  templateUrl: './overzicht.component.html',
  styleUrls: ['./overzicht.component.scss']
})
export class OverzichtComponent implements OnInit {
  berichten$: Observable<Bericht[]>;

  constructor(private berichtenService: BerichtenService) { }

  ngOnInit() {
    this.berichten$ = this.berichtenService.get();
  }

}
